<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Update Profile</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-content-start
          justify-center
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-text-field
              v-model="txtEmail"
              :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail format is invalid']"
              :counter="150"
              label="E-mail"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtName"
              :rules="[v => !!v || 'Name is required']"
              :counter="100"
              label="Name"
              required
            ></v-text-field>
            <v-select
              v-model="cboTimezone"
              :items="timezones"
              :rules="[v => !!v || 'Please select timezone']"
              label="Timezone"
              required
            ></v-select>
            <v-btn
              :disabled="!frmValid"
              @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data: () => ({
    drawer: false,
    loading: false,
    frmValid: true,
    txtEmail: '',
    txtName: '',
    cboTimezone: ''
  }),

  mounted () {
    this.openDrawerForDesktop()
    this.getMyProfile()
  },

  methods: {
    getMyProfile: function (adminId) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/me')
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.txtEmail = resp.data.data.email
            this.txtName = resp.data.data.name
            this.cboTimezone = resp.data.data.gmtTimezone
          } else {
            console.log('unable to load my details: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/me', {
          email: this.txtEmail,
          name: this.txtName,
          gmtTimezone: this.cboTimezone
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.$store.dispatch('UPDATE_PROFILE')
              window.alert('Profile updated')
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    }
  }
}
</script>
